import { Drawer, DrawerContent, DrawerTitle } from '../ui/drawer';
import { Dialog, DialogContent, DialogTitle } from '@/client/components/ui/dialog';
import { cn } from '@/client/utils';
import { PropsWithChildren } from 'react';
import useMedia from 'react-use/lib/useMedia';

type DrawerDiaLogTitleProps = PropsWithChildren & {
  className?: string;
};
export const DrawerDiaLogTitle = ({ children, className }: DrawerDiaLogTitleProps) => {
  const isDesktop = useMedia('(min-width: 768px)');
  if (isDesktop) return <DialogTitle className={className}>{children}</DialogTitle>;
  return <DrawerTitle className={className}>{children}</DrawerTitle>;
};

export type DrawerDiaLogProps = PropsWithChildren & {
  className?: string;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  disableOutside?: boolean;
};
export const DrawerDiaLog = ({ open, setOpen, children, className, disableOutside }: DrawerDiaLogProps) => {
  const isDesktop = useMedia('(min-width: 768px)');
  const onInteractOutside = disableOutside ? (e: any) => e.preventDefault() : undefined;
  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          aria-describedby={undefined}
          onInteractOutside={onInteractOutside}
          onOpenAutoFocus={e => e.preventDefault()}
          className={cn('gap-0 p-0 max-w-auto border-foreground/10 block', className)}
        >
          {children}
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Drawer open={open} onOpenChange={setOpen} repositionInputs={false}>
      <DrawerContent
        aria-describedby={undefined}
        onInteractOutside={onInteractOutside}
        onOpenAutoFocus={e => e.preventDefault()}
        className="w-full max-h-[calc(100%-52px)]"
      >
        <div className={cn('px-5 pb-5 h-full overflow-y-auto', className)}>{children}</div>
      </DrawerContent>
    </Drawer>
  );
};
